module.exports = "2947203"


// WEBPACK FOOTER //
// ./src/contracts/Cryptogs.3.blockNumber.js